// filter.component.ts
import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-filter',
  templateUrl: './filter.component.html',
  styleUrls: ['./filter.component.scss'],
})
export class FilterComponent {
  selectedFilters: string[] = [];
  filteredData: any[] = [];

  @Input() allData: any[] = [];
  @Input() filterOptions: string[] = [];
  @Output() filteredDataOutput = new EventEmitter<any[]>();

  constructor() {}

  updateFilteredData(): void {
    this.filteredData = this.allData.filter(
      (item) =>
        this.selectedFilters.length === 0 ||
        this.selectedFilters.includes(item.category)
    );
    this.filteredDataOutput.emit(this.filteredData);
  }
}
